﻿import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { FormGroup, FormControl, NgForm, ReactiveFormsModule } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { Constants } from '../../../../_utils/Constants';
import { APILoginService } from '../../_services/login/API-login';
import { LoginComponent } from '../login/login.component';
import { $ModalManagerService } from '../../../../_helpers/Modals/ModalManager.service';
import * as crypto from 'crypto-js';
import { $BroadcastManagerService } from '../../../../_helpers/BroadcastManager.service';
import { APIConstants } from '../../../../_config/restapis';


@Component({
  selector: 'app-common-login',
  templateUrl: './common-login.component.html',
  styleUrls: ['./common-login.component.css']
})
export class CommonLoginComponent implements OnInit {

  form: FormGroup;
  public role: any;
  public entityType: any;
  public user: any;
  public userN: any;
  public readonly: boolean = false;
  public OTP_clicked: boolean = false;
  public showGenerateOTP: boolean = false;
  homeRole: boolean = false;
  mobilenumber: any;
  errorUser: boolean = false;
  errorOtp: boolean = false;
  errorReg: boolean = false;
  EntityId: any;
  Entity_Name: any;
  Entity_Ref_No: any;
  Entity_User_Name: any;
  Entity_Org: any;
  E_Org_Name: any;
  Entity_EmailID: any;
  mob: any;
  roleSelected: any;
  hide = true;
  commonLoginForm: FormGroup;
  submitted: boolean = false;
  public loginFlag = false;
  MobileNumber: number;
  constructor(private formBuilder: FormBuilder,
    private router: Router,
    private db: $DBManagerService,
    private ls: APILoginService,
    private _route: ActivatedRoute,
    private $modal: $ModalManagerService,
    private evt: $BroadcastManagerService) {
      this._route.params.subscribe((params) => {
        this.roleSelected = params['role'];
        
        let userR = params['role'];
		console.log("userR :",userR);
		if(userR == "Tata Employee"){
			this.router.navigateByUrl('/');
		}

      })
     }

  ngOnInit() {

  this.commonLoginForm = this.formBuilder.group({
      emailID: ['', [Validators.required]],
     // tslint:disable-next-line:max-line-length
     // password: ['', [Validators.required,Validators.pattern('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&].{8,}') ]],
      password: ['', [Validators.required]],
      otp: ['', []],
      phoneNumber: ['', []],
      //role: ['', [Validators.required]]
    });



    this.db.clearDB();
    this.evt.emit({ 'click': 'HEADER_EVENT' });
    this.evt.emit({ 'click': 'HEADER_EVENT_' });
  }

get f() {
    return this.commonLoginForm.controls;
  }
   // onChange(role) {
   // console.log("role :", role.value);
   // this.role = role.value;
  //}

  // show password function 
  showPassword()
  {

  }

  onSubmit() {
  
    this.submitted = true;

    if(this.commonLoginForm.invalid) {
     console.log("invalid form: ", this.commonLoginForm);
      return;
    }
    else {
     // console.log("inside else ",this.commonLoginForm);
    //  console.log("f.........",this.roleSelected);
    //this.db.set(Constants.SESSSION_STORAGE, Constants.USER_ROLE, this.entityType);
	console.log("IS IT COMING1 ",this.roleSelected);
      if (this.roleSelected == "Observer") {
	  console.log("IS IT COMING ");
        this.entityType = "Tata Employee";
        var data2 = {
          //"Entity_Class": this.roleSelected,
		   "Entity_Class": "Tata Employee",
          "Entity_EmailID":this.f.emailID.value,
          //"Entity_User_Name": this.f.emailID.value,
        "Entity_Password": this.f.password.value
      };
      console.log("check the data",data2)
     // console.log("role........", this.role);
      this.db.set(Constants.SESSSION_STORAGE, Constants.USER_ROLE, this.entityType);
      this.loginAPI(data2);
    }

      else if ((this.roleSelected == "PE" || this.roleSelected == "TM") && !this.f.otp.value) {
        var data = {
            "Entity_Class": this.roleSelected,
            "Entity_EmailID":this.f.emailID.value,
        //"Entity_User_Name": this.f.userName.value,
        "Entity_Password": this.f.password.value
      };
     // this.db.set(Constants.SESSSION_STORAGE, Constants.USER_ROLE, this.roleSelected);
      this.loginAPI(data);
     // this.verifyOTP(this.f.otp.value);
    }
    else if (this.f.otp.value) {
	
      var data = {
        "Entity_Class": this.roleSelected,
        "Entity_EmailID":this.f.emailID.value,
    //"Entity_User_Name": this.f.userName.value,
    "Entity_Password": this.f.password.value
  };
  //this.db.set(Constants.SESSSION_STORAGE, Constants.USER_ROLE, this.entityType);
  this.loginAPI(data);
      this.db.set(Constants.SESSSION_STORAGE, Constants.USER_ROLE, this.roleSelected);
      this.verifyOTP(this.f.otp.value);
    }
    //console.log("this.loginFlag before frersponse:", this.loginFlag);
  }

  }

  downloadRegprocess(){
    let link =document.createElement('a');
    link.setAttribute('type', 'hidden');
    link.href = '../../../../../assets/DLT_Registration_Process.pdf';
    link.download = 'DLT Registration Process';
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  //Check username, Pwd from mongo
  loginAPI(data) {
   // console.log("tata emp  data.... : ", data);
    this.ls.login(data)
      .subscribe((r) => {
       // console.log("sunscribe r mesasge :",r.message);

        if (r.message == "login success") {
         // console.log("username check ___ :", r.entityObj.Entity_Name);

          this.evt.emit({ 'click': 'HEADER_EVENT' });
          this.evt.emit({ 'click': 'HEADER_EVENT_' });

          this.readonly = true;
          this.db.set(Constants.SESSSION_STORAGE, Constants.USER_NAME, this.userN);
          this.user = this.db.get(Constants.SESSSION_STORAGE, Constants.USER_NAME);
          this.db.set(Constants.SESSSION_STORAGE, Constants.HOME_ROLE, this.homeRole);
          this.db.set(Constants.SESSSION_STORAGE, Constants.ENTITY_ID, r.entityObj.Entity_ID);
          this.db.set(Constants.SESSSION_STORAGE, Constants.ENTITY_REF_NO_LOGIN, r.entityObj.Entity_Ref_No);
          this.db.set(Constants.SESSSION_STORAGE, Constants.ENTITY_NAME, r.entityObj.Entity_Name);
          this.db.set(Constants.SESSSION_STORAGE, Constants.USER_NAME, r.entityObj.Entity_User_Name);
          this.db.set(Constants.SESSSION_STORAGE, Constants.ORG_NAME,r.entityObj.E_Org_Name);
          this.db.set(Constants.SESSSION_STORAGE, Constants.ENTITY_CONTACTNAME,r.entityObj.Entity_ContactName);
			console.log("Helllo",r.entityObj);
		this.db.set(Constants.SESSSION_STORAGE, Constants.ORG_TYPE,r.entityObj.E_Org_Type);
          this.db.set(Constants.SESSSION_STORAGE, Constants.ENTITY_ADDR,r.entityObj.Entity_Addr);
          this.db.set(Constants.SESSSION_STORAGE, Constants.ENTITY_CLASS,r.entityObj.Entity_Class);
          this.db.set(Constants.SESSSION_STORAGE, Constants.Hash_KYC_Doc,r.entityObj.Hash_KYC_Doc);
		  
		  this.db.set(Constants.SESSSION_STORAGE, Constants.Entity_EmailID,r.entityObj.Entity_EmailID);
		  //this.db.set(Constants.SESSSION_STORAGE, Constants.INDUSTRY,r.entityObj.Industry);
          this.db.set(Constants.SESSSION_STORAGE, Constants.INDUSTRYSECTOR,r.entityObj.IndSector);
		  this.db.set(Constants.SESSSION_STORAGE, Constants.ENTITY_MOBILE_NO,r.entityObj.Entity_Mobile_No);
		  
			console.log("r.entityObj",r.entityObj)
          this.EntityId = r.entityObj.Entity_ID;
          console.log("this.EntityId",this.EntityId)
          this.Entity_Ref_No = r.entityObj.Entity_Ref_No;
	//  console.log("entity ref number",this.Entity_Ref_No)
          this.Entity_Name = r.entityObj.Entity_Name;
          this.Entity_User_Name = r.entityObj.Entity_User_Name;
          this.E_Org_Name = r.entityObj.E_Org_Name;
          this.Entity_EmailID = r.entityObj.Entity_EmailID;
          this.MobileNumber = r.entityObj.Entity_Mobile_No;
          this.errorReg = false;
          this.errorUser = false;
           switch (this.roleSelected) {


            //case "Tata Employee":
			  case "Observer":
              this.loginFlag = true;
          //    console.log(" inside case tata");
              this.user = "Tata Employee";
              this.userN = this.f.emailID.value;
              this.homeRole = true;
              this.db.set(Constants.SESSSION_STORAGE, Constants.HOME_ROLE, this.homeRole);
              this.db.set(Constants.SESSSION_STORAGE, Constants.LOGIN_FLAG, this.loginFlag);
              this.db.set(Constants.SESSSION_STORAGE,Constants.ENTITY_ROLE, r.entityObj.Entity_Role);
				this.db.set(Constants.SESSSION_STORAGE, Constants.ENTITY_CONTACTNAME,r.entityObj.Entity_ContactName);
				console.log("Helllo",r.entityObj);
             // console.log(" this.user :", this.user);
             localStorage.setItem('currentUser', "TATA");
              //this.router.navigateByUrl('/import-preference');
			   this.router.navigateByUrl('/dashboard');
              break;
            case "TM":
            localStorage.setItem('currentUser', "RTM");
              this.showGenerateOTP = true;
              document.getElementById('GenerateOTP').style.backgroundColor="#f8d7da"; 
              this.readonly = true;
             //this.generateOTP(r.entityObj.Entity_Mobile_No);
             //this.generateOTP();
            case "PE":
            localStorage.setItem('currentUser', "PE");
              this.showGenerateOTP = true;
               document.getElementById('GenerateOTP').style.backgroundColor="#f8d7da";

              this.readonly = true;
             // this.generateOTP(r.entityObj.Entity_Mobile_No);
            //  this.generateOTP();

            default:
              break;
          }
        }
        else if (r.message == "unapproved registration"){
          this.errorReg = true;
          this.errorUser = false;
        }
        else{
          this.errorUser = true;
          this.errorReg = false;
        }
      });
  }
  // checking username, pwd frm mongodb ends here


  // sending the otp to PE and RTM when username exists
  generateOTP() {
   // console.log("next step: generate otp");
    this.OTP_clicked = true;
   // console.log("mobilenumber :", mobilenumber);
    // let mobilnumber = 9640393664;
    let concat =91
    this.mobilenumber = concat+''+this.MobileNumber;
    //this.mob = APIConstants.OTPDIR[mobilnumber];
    var otp = {
      "mobileNo": this.mobilenumber
    }
    console.log("generate otp",otp)
    this.ls.generateOtpEntity(otp)
      .subscribe((r) => {
        if (r.message == "OTP successfully sent.") {
          this.db.set(Constants.SESSSION_STORAGE,Constants.USERID_OTP, r.userid);
          var data = {

            "notificationType" : "sendOTP",
            "identifier": this.mob
            };
            this.ls.otpNotification(data)
             .subscribe((r) => {
            //  this.$modal.successModal({
             //   title: 'Notification',
             //   msg: 'Otp has been sent'
             // });
            })
        //  console.log("otp sent ");
        }
        else {
       //   console.log("Internal Error while sending OTP!");
        }
      })
  }

  verifyOTP(otp) {
	this.homeRole = false;
    this.loginFlag = false;
	  this.db.set(Constants.SESSSION_STORAGE, Constants.LOGIN_FLAG, this.loginFlag);
      this.db.set(Constants.SESSSION_STORAGE, Constants.HOME_ROLE, this.homeRole);
    if(otp == "9999"){
     console.log("otp verified",this.roleSelected);
      this.homeRole = true;
      this.loginFlag = true;
      this.db.set(Constants.SESSSION_STORAGE, Constants.LOGIN_FLAG, this.loginFlag);
      this.db.set(Constants.SESSSION_STORAGE, Constants.HOME_ROLE, this.homeRole);
      this.db.set(Constants.SESSSION_STORAGE, Constants.ENTITY_ID, this.EntityId);

      this.db.set(Constants.SESSSION_STORAGE, Constants.USER_NAME, this.userN);
      this.user = this.db.get(Constants.SESSSION_STORAGE, Constants.USER_NAME);
     // console.log("login get inside verify :",this.db.get(Constants.SESSSION_STORAGE, Constants.LOGIN_FLAG));
      this.db.set(Constants.SESSSION_STORAGE, Constants.USER_NAME, this.Entity_User_Name);
      this.db.set(Constants.SESSSION_STORAGE, Constants.USER_ROLE, this.roleSelected);

      this.evt.emit({ 'click': 'HEADER_EVENT' });
      this.evt.emit({ 'click': 'HEADER_EVENT_' });


      var otpp = {
        "mobileNo": this.mob
      }
     var data =
     {
       "otp": otpp,
       "notificationType" : "verifyOTP",
       "identifier": this.mob
       };
     this.ls.otpNotification(data)
     .subscribe((r) => {
    
    })
      if(this.roleSelected == "TM"){
        this.router.navigateByUrl('/header-voice-summary');
      }
      else{
        this.router.navigateByUrl('/new-header-registration');
      }

    }
    else if(otp != "9999")
    {
	  this.evt.emit({ 'click': 'HEADER_EVENT' });
      this.evt.emit({ 'click': 'HEADER_EVENT_' });
	  this.homeRole = false;
      this.loginFlag = false;
	  //this.roleSelected = null;
	  this.db.set(Constants.SESSSION_STORAGE, Constants.LOGIN_FLAG, this.loginFlag);
      this.db.set(Constants.SESSSION_STORAGE, Constants.HOME_ROLE, this.homeRole);
      this.db.set(Constants.SESSSION_STORAGE, Constants.ENTITY_ID, this.EntityId);
	  //this.db.set(Constants.SESSSION_STORAGE, Constants.USER_ROLE, this.roleSelected);
      console.log("it is not 9999")
      this.errorOtp = true;
    }
    else{
   // let mobilenumber = this.mobilenumber;
  //  let email = APIConstants.OTPDIR[mobilenumber];
    var verify = {
      "mobileNo": this.mobilenumber,
      "OTP": this.f.otp.value
    }
    this.ls.verifyOtpEntity(verify)
      .subscribe((r) => {
        if (r.message == "OTP verified successfully") {
          this.evt.emit({ 'click': 'HEADER_EVENT' });
          this.evt.emit({ 'click': 'HEADER_EVENT_' });
          this.homeRole = true;
          this.loginFlag = true;
          this.db.set(Constants.SESSSION_STORAGE, Constants.LOGIN_FLAG, this.loginFlag);
          this.db.set(Constants.SESSSION_STORAGE, Constants.HOME_ROLE, this.homeRole);
          this.db.set(Constants.SESSSION_STORAGE, Constants.ENTITY_ID, this.EntityId);
    
          this.db.set(Constants.SESSSION_STORAGE, Constants.USER_NAME, this.userN);
          this.user = this.db.get(Constants.SESSSION_STORAGE, Constants.USER_NAME);
         // console.log("login get inside verify :",this.db.get(Constants.SESSSION_STORAGE, Constants.LOGIN_FLAG));
          this.db.set(Constants.SESSSION_STORAGE, Constants.USER_NAME, this.Entity_User_Name);
          console.log(this.roleSelected)
          this.db.set(Constants.SESSSION_STORAGE, Constants.USER_ROLE, this.roleSelected);
         var data =

          {
            "otp": otp,
            "notificationType" : "verifyOTP",
            //"identifier": email
            };

         this.ls.otpNotification(data)
         .subscribe((r) => {
          this.$modal.successModal({
            title: 'Notification',
            msg: 'Otp has been verified'
          });
         })
          switch (this.roleSelected) {

            case "TM":

              this.user = "TM";
              this.router.navigateByUrl('/message-delivery');
              break;
            case "PE":

              this.user = "PE";
              this.router.navigateByUrl('/new-header-registration');
              break;

            default: 
              break;
          }

        }
        else{
          this.errorOtp = true;
        }

      })

    }


  }

}

